import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'
import { Box, TextField } from '@material-ui/core'

import schema from './schema'
import theme from 'theme'
import { Alert } from '@material-ui/lab'

const AddInviteAdvisor = ({ onSubmit, disabled, setDisabled, invite }) => {
  const { control, handleSubmit, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      email: invite?.email ?? '',
    },
  })

  useEffect(() => {
    if (disabled) setDisabled(false)
    //eslint-disable-next-line
  }, [disabled])

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(3)}
      my={2}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      id="inviteAdvisorForm"
    >
      <Alert severity="warning">
        Esta ação arquivará automaticamente os projetos de governança vinculados
        ao grupo advisor de origem.
      </Alert>
      <Controller
        as={
          <TextField
            label="Email"
            type="email"
            color="primary"
            variant="outlined"
            error={!!errors.email}
            helperText={errors?.email?.message}
            fullWidth
          />
        }
        control={control}
        name="email"
        mode="onBlur"
      />
    </Box>
  )
}

AddInviteAdvisor.propTypes = {
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  setDisabled: PropTypes.func,
  invite: PropTypes.object,
}

AddInviteAdvisor.defaultProps = {
  onSubmit: () => {},
  setDisabled: () => {},
  invite: {},
}

export default AddInviteAdvisor
